import { createSelector } from 'reselect';
import { RootState } from '../types';

export const getNetwork = (state: RootState) => state.network;

export const getIsConnected = createSelector(getNetwork, network => network.isConnected);

/**
 * For checking specifically for wifi
 * Note this doesn't 100% guarantee that the wifi connection has internet
 */
export const getIsWifiConnection = createSelector(
  getNetwork,
  network => network.type === true // NetInfoStateType.wifi
);
